import { $$ } from '../../lib/dom';
import { logger } from '../../lib/logger';

/** `[data-copy]` buttons copy their value; the label only changes once the copy actually succeeded. */
export function initCopyButtons(root: HTMLElement): void {
  $$('[data-copy]', root).forEach((button) => {
    button.addEventListener('click', () => {
      const value = button.dataset.copy ?? '';
      navigator.clipboard.writeText(value).then(
        () => {
          button.textContent = 'Link copied';
        },
        (error: unknown) => {
          logger.warn('Could not copy the link.', error);
        },
      );
    });
  });
}
